import React from 'react';
import EvaluatorExport from '../../Evaluator/EvaluatorExport/EvaluatorExport';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ExportSapReconciliationWindowDescription from './ExportSapReconciliationWindowDescription';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import ExportQBOInvoiceReportWindowDescription from './ExportQBOInvoiceReportWindowDescription';
import QBOInvoiceReportSearchParams from './QBOInvoiceReportSearchParams';
import UserService from '../../../Services/userService';
import ExportQBOCreditMemoReportWindowDescription from './ExportQBOCreditMemoReportWindowDescription';
import ExcelDataExportSearchParams from './ExcelDataExportSearchParams';
import ExcelDataExportWindowDescription from './ExcelDataReportWindowDescription';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ARAgeingReportSearchParams from './ARAgeingReportSearchParams';
import ARAgeingReportWindowDescription from './ARAgeingReportWindowDescription';
import EvaluatorPaymentsExportSearchParams from './EvaluatorPaymentsExportSearchParams';
import EvaluatorPaymentsExportWindowDescription from './EvaluatorPaymentsExportWindowDescription';
import TpRevenueByRevenuePeriodReportWindowDescription from './TpRevenueByRevenuePeriodReportWindowDescription';
import TpRevenueByRevenuePeriodSearchParams from './TpRevenueByRevenuePeriodSearchParams';
import UnappliedPrepaymentReportSearchParams from './UnappliedPrepaymentReportSearchParams';
import UnappliedPrepaymentReportWindowDescription from './UnappliedPrepaymentReportWindowDescription';
import EvaluatorLeadReportSearchParams from './EvaluatorLeadReportSearchParams';
import EvaluatorLeadReportWindowDescription from './EvaluatorLeadReportWindowDescription';
import EvaluatorCountReportSearchParams from './EvaluatorCountReportSearchParams';
import EvaluatorCountReportWindowDescription from './EvaluatorCountReportWindowDescription';

import ReportLauncherPage from '../../../Elements/ReportLauncher/ReportLauncherPage';
import buildReportAdminSections from './ReportAdminSections';

export default class ReportAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      shownPanel: ShownPanelsEnum.None,
    };
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  renderPanels() {
    const searchItem = new QBOInvoiceReportSearchParams();
    searchItem.OfficeId = UserService.GetOfficeIdOfLoggedInUser();
    searchItem.NotExportedYet = true;
    searchItem.SearchType = 'Export Status';
    searchItem.StatusCode = [2];
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.ReconcileExport,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={{
              FinalizedBefore: new Date(dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(new Date(), 1))),
              FinalizedAfter: new Date('2020-01-01'),
            }}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={ExportSapReconciliationWindowDescription}
            errorCode='RA43'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.QboInvoiceExport,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={searchItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={ExportQBOInvoiceReportWindowDescription}
            errorCode='RA37'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.QboCreditMemoExport,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={searchItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={ExportQBOCreditMemoReportWindowDescription}
            errorCode='RA59'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.ExcelDataExport,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new ExcelDataExportSearchParams()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={ExcelDataExportWindowDescription}
            errorCode='RA86'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.ARAgeingReport,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new ARAgeingReportSearchParams()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={ARAgeingReportWindowDescription}
            errorCode='RA102'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EvaluatorPaymentsExport,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new EvaluatorPaymentsExportSearchParams()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={EvaluatorPaymentsExportWindowDescription}
            errorCode='RA114'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.TpRevenueByRevenuePeriodReport,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new TpRevenueByRevenuePeriodSearchParams()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={TpRevenueByRevenuePeriodReportWindowDescription}
            errorCode='RA120'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.UnappliedPrepaymentReport,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new UnappliedPrepaymentReportSearchParams()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={UnappliedPrepaymentReportWindowDescription}
            errorCode='RA130'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EvaluatorLeadReport,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new EvaluatorLeadReportSearchParams()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={EvaluatorLeadReportWindowDescription}
            errorCode='RA140'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EvaluatorCountReport,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new EvaluatorCountReportSearchParams()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={EvaluatorCountReportWindowDescription}
            errorCode='RA140'
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <>
        <EvaluatorExport />
        <ReportLauncherPage
          sections={buildReportAdminSections((panel) => this.setState({ shownPanel: panel }))}
          overlay={this.renderPanels()}
        />
      </>
    );
  }
}
